import { render, staticRenderFns } from "./FileModal.vue?vue&type=template&id=a4cf9ac0"
import script from "./FileModal.vue?vue&type=script&lang=js"
export * from "./FileModal.vue?vue&type=script&lang=js"
import style0 from "./FileModal.vue?vue&type=style&index=0&id=a4cf9ac0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports